/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import Axios, { AxiosRequestConfig } from "axios";

const axios = Axios.create();

axios.interceptors.request.use((req) => {
  req.baseURL = process.env.VUE_APP_SALUTARIA_API_URL + "/api/upload";
  req.headers!.authorization = `Bearer ${localStorage.authToken}`;
  // req.headers.origin = process.env.BASE_URL;
  return req;
});
export default {
  uploadFile(file: Blob, fileName: string) {
    const formData = new FormData();
    formData.append("file", file, fileName);
    const options: AxiosRequestConfig = {
      method: "post",
      url: "/helper",
      data: formData,
      // withCredentials: false,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    return axios(options);
  },
};
